import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Button, ButtonSize, ButtonVariant } from "@wattpad/web-ui-library";
import { ConnectImage } from "../../../shared-components";
import {
  initGoogleSignIn,
  initGoogleSignInTokenClient
} from "./helpers/google";
import { useTrans } from "../../../hooks";

const handleGoogleAuth = ({ nextUrl }) => {
  // Possibly not needed with new event and using Intersect Observ. Delete once confirmed.
  // Should probably be controlled by the parent component too.
  // if (source === "login") {
  //   window.te.push("event", "landing", null, null, "login", {
  //     platform: "google"
  //   });
  // }
  const tokenClient = initGoogleSignInTokenClient({
    clientId: wattpad.googleClientId, // currently comes from application config. Should probably live in SaaS config.
    nextUrl
  });

  tokenClient.requestAccessToken();
};

// TOOD: isolate the google login button styles from the login, signup and other CSS modules.
// Do the same for the other buttons/interactions. Then figure out common styles and share them.
const ButtonLabel = ({ action }) => {
  const { trans } = useTrans();

  return (
    <>
      <ConnectImage
        name="/shared/google_login_color.png"
        title="Google Login"
        width="18"
        className="google-login-icon"
        aria-hidden="true"
      />
      <span>
        <span className="auth-button-text-new">
          {action === "login"
            ? trans("Log in with Google")
            : trans("Sign up with Google")}
        </span>
      </span>
    </>
  );
};

export function GoogleSSOButton({ action, nextUrl }) {
  useEffect(() => {
    initGoogleSignIn();
  }, []);

  return (
    <Button
      variant={ButtonVariant.SECONDARY}
      size={ButtonSize.MEDIUM}
      fullWidth
      onClick={() => handleGoogleAuth({ nextUrl })}
      label={<ButtonLabel action={action} />}
    />
  );
}

GoogleSSOButton.propTypes = {
  nextUrl: PropTypes.string,
  action: PropTypes.oneOf(["login", "signup"])
};

ButtonLabel.propTypes = {
  action: PropTypes.oneOf(["login", "signup"])
};
